import React, { useRef, useEffect, useState } from "react";
import { Tabs, Image, Avatar, Badge, Collapse, Tag, Skeleton, Space } from "antd";
import parse from "html-react-parser";
import moment from "moment-timezone";
import {
  ProfileOutlined,
  InfoCircleOutlined,
  StarFilled,
  ClockCircleOutlined,
  HeartOutlined,
  EnvironmentOutlined,
  TeamOutlined,
  IdcardOutlined,
  EyeInvisibleOutlined,
  UserOutlined,
  PictureOutlined,
} from "@ant-design/icons";

import NOIMAGE from "assets/images/no_image.jpeg";

import MemoComponent from "./MemoComponent";
import MediaComponent from "./MediaComponent";
import NotesComponent from "./NotesComponent";

import { getToken } from "services/token-service/token.service";

import "./ProfileView.scss";

const { TabPane } = Tabs;
const { Panel } = Collapse;

const ProfileView = (props) => {
  const { type, data } = props;
  const token = getToken();
  const profileImageRef = useRef();
  const profileDetailsRef = useRef();
  const profileTabsRef = useRef();
  const [infoTabHeight, setInfoTabHeight] = useState(null);
  useEffect(() => {
    data &&
      setInfoTabHeight(
        window.innerHeight -
          profileImageRef.current.clientHeight -
          profileDetailsRef.current.clientHeight -
          40
      );
  }, [data]);
  console.log('TYPE ===> ', type);

  const stringToHTML = (text) => {
    var parser = new DOMParser();
    var doc = parser.parseFromString(text, "text/html");
    return <React.Fragment>{parse(doc.body.innerHTML)}</React.Fragment>;
  };

  const renderUserInfo = () => {
    return (
      <div className="UserInfoContainer" style={{ height: infoTabHeight }}>
        <div className="listItem CreditsInfo">
          <span>Credits:</span>
          <span>
            {data?.user_profile.credits_left > 0
              ? data?.user_profile.credits_left
              : 0}
          </span>
        </div>
        <div className="listItem">
          <div className="LabelItemContainer">
            <ClockCircleOutlined />
            <div className="listItemLabel">Local Time:</div>
          </div>
          <span>
            {data?.user_profile?.timezone
              ? moment().tz(data?.user_profile.timezone).format("HH:mm:ss")
              : "/"}
          </span>
        </div>
        <div className="listItem">
          <div className="LabelItemContainer">
            <HeartOutlined />
            <div className="listItemLabel">Looking For:</div>
          </div>
          <span>{data?.user_profile.looking_for}</span>
        </div>
        <div className="listItem">
          <div className="LabelItemContainer">
            <TeamOutlined />
            <div className="listItemLabel">Status:</div>
          </div>
          <span>
            {data?.user_profile.civil_status
              ? data?.user_profile.civil_status
              : "None"}
          </span>
        </div>
        <div className="listItem">
          <div className="LabelItemContainer">
            <EnvironmentOutlined />
            <div className="listItemLabel">City:</div>
          </div>
          <span>{data?.user_profile.city}</span>
        </div>
        <div className="listItem">
          <div className="LabelItemContainer">
            <IdcardOutlined />
            <div className="listItemLabel">Age:</div>
          </div>
          <span>{data?.user_profile.age}</span>
        </div>
        <Collapse
          defaultActiveKey={["2"]}
          // onChange={onChange}
        >
          <Panel header="User Description" key="1">
            {data?.user_profile.description
              ? stringToHTML(data?.user_profile.description)
              : "User has added no description"}
          </Panel>
          <Panel header="User Interests" key="2">
            {data?.user_profile.interests &&
            data?.user_profile.interests.length > 0
              ? data?.user_profile.interests.map((interest, index) => {
                  return (
                    <Tag color="blue" key={index}>
                      {interest}
                    </Tag>
                  );
                })
              : "User has added no Interests"}
          </Panel>
        </Collapse>
      </div>
    );
  };

  const renderProfileInfo = () => {
    return (
      <div className="UserInfoContainer" style={{ height: infoTabHeight }}>
        <div className="listItem">
          <div className="LabelItemContainer">
            <PictureOutlined />
            <div className="listItemLabel">Photos:</div>
          </div>
          <span>{data?.fictitious_profile.photos_count}</span>
        </div>
        <div className="listItem">
          <div className="LabelItemContainer">
            <EyeInvisibleOutlined />
            <div className="listItemLabel">Hidden:</div>
          </div>
          <span>{data?.fictitious_profile.message_photos_count}</span>
        </div>
        <div className="listItem">
          <div className="LabelItemContainer">
            <UserOutlined />
            <div className="listItemLabel">Name:</div>
          </div>
          <span>{data?.fictitious_profile.real_name}</span>
        </div>
        <div className="listItem">
          <div className="LabelItemContainer">
            <TeamOutlined />
            <div className="listItemLabel">Status:</div>
          </div>
          <span>
            {data?.fictitious_profile.civil_status
              ? data?.fictitious_profile.civil_status
              : "None"}
          </span>
        </div>
        <div className="listItem">
          <div className="LabelItemContainer">
            <IdcardOutlined />
            <div className="listItemLabel">Age:</div>
          </div>
          <span>{data?.fictitious_profile.age}</span>
        </div>
        <Collapse
          defaultActiveKey={["3"]}
          // onChange={onChange}
        >
          <Panel header="User Description" key="1">
            {data?.fictitious_profile.description
              ? stringToHTML(data?.fictitious_profile.description)
              : "User has added no description"}
          </Panel>
          <Panel header="User Interests" key="2">
            {data?.fictitious_profile.interests &&
            data?.fictitious_profile.interests.length > 0
              ? data?.fictitious_profile.interests.map((interest, index) => {
                  return (
                    <Tag color="blue" key={index}>
                      {interest}
                    </Tag>
                  );
                })
              : "User has added no Interests"}
          </Panel>
          <Panel header="Media" key="3">
            {data && <MediaComponent convData={data} />}
          </Panel>
        </Collapse>
      </div>
    );
  };

  return (
    <div className="ProfileView">
      <div className="ProfileImage" ref={profileImageRef}>
        <Image
          // width={200}
          src={
            type === "user"
              ? data?.user_profile.profile_image
                ? `${data?.user_profile.profile_image}?token=${token}`
                : NOIMAGE
              : data?.fictitious_profile.profile_image ? data?.fictitious_profile.profile_image : NOIMAGE
          }
        />
      </div>
      
      <div className="ProfileDetails" ref={profileDetailsRef}>
      { data ? <>
        <Avatar
          size={32}
          src={
            type === "user"
              ? data?.user_profile.profile_image
                ? `${data?.user_profile.profile_image}?token=${token}`
                : NOIMAGE
              : data?.fictitious_profile.profile_image
          }
        />
        <div className="UsernameAge">
          {/* Alew White, 38 */}
          {type === "user" ? (
            <React.Fragment>
              {data?.user_profile.username}, {data?.user_profile.age}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {data?.fictitious_profile.username},{" "}
              {data?.fictitious_profile.age}
            </React.Fragment>
          )}
        </div>
        {type === "user" ? (
          data?.user_profile.online_status ? (
            <div className="OnlineStatus">
              <Badge color="green" />
            </div>
          ) : (
            <div className="OnlineStatus">
              <Badge color="grey" />
            </div>
          )
        ) : data?.fictitious_profile.online_status ? (
          <div className="OnlineStatus">
            <Badge color="green" />
          </div>
        ) : (
          <div className="OnlineStatus">
            <Badge color="grey" />
          </div>
        )}
        {type === "user" && data?.user_profile.premium ? (
          <div className="PremiumStatus">
            <StarFilled />
          </div>
        ) : (
          ""
        )}
        </> 
         : 
         <Space>
           <Skeleton.Avatar active={false} size="default" shape="circle" />
           <Skeleton.Input active={false} size="default" />
         </Space>}
      </div> 
     
      <div className="ProfileInfoMemo">
      { data ? 
        <Tabs defaultActiveKey="1" centered={true}>
          <TabPane
            tab={
              <span ref={profileTabsRef}>
                <InfoCircleOutlined />
                Info
              </span>
            }
            key="1"
          >
            {type === "user" ? renderUserInfo() : ""}
            {type === "profile" ? renderProfileInfo() : ""}
          </TabPane>
          <TabPane
            tab={
              <span>
                <ProfileOutlined />
                Memo
              </span>
            }
            key="2"
          >
            <MemoComponent
              infoTabHeight={infoTabHeight}
              type={type}
              id={
                type === "user"
                  ? data?.user_profile.id
                  : data?.fictitious_profile.id
              }
            />
          </TabPane>
          <TabPane
            tab={
              <span>
                <ProfileOutlined />
                Notes
              </span>
            }
            key="3"
          >
            <NotesComponent
              infoTabHeight={infoTabHeight}
              type={type}
              profileUsername={data?.fictitious_profile.username}
              userProfileUsername={data?.user_profile.username}
            />
          </TabPane>
        </Tabs> : 
        <>
          <Skeleton />
          <Skeleton />
        </>
        }
      </div>
    </div>
  );
};

export default ProfileView;
